import { Box, Stack } from '@mui/material';
import { UserCountsResponseDTO } from 'wisestep-api';
import { PageStats, WsTitleBanner } from 'wisestep-base';

import { WsBreadCrumbs } from '../../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';

export interface IUsersBannerProps {
  userCounts: UserCountsResponseDTO;
  maxInvites: number;
}
const UsersBanner = ({ userCounts, maxInvites }: IUsersBannerProps) => {
  const UsersPageAnalytics = (
    <Stack direction={'row'} spacing={2}>
      <PageStats statTitle="Maximum User Limit" statValue={maxInvites} />
      <PageStats statTitle="Activated" statValue={userCounts.activated} />
      <PageStats statTitle="Invited" statValue={userCounts.invited} />
      <PageStats statTitle="Deactivated" statValue={userCounts.deactivated} />
      <PageStats statTitle="Pending Invites" statValue={maxInvites - userCounts.activated} />
    </Stack>
  );

  return (
    <Box py={3}>
      <WsBreadCrumbs
        breadCrumbsList={getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.TEAMS_AND_USERS,
          Pages['USERS']
        )}
      />
      <WsTitleBanner title="Users" rightChildren={UsersPageAnalytics} backButton={false} />
    </Box>
  );
};

export default UsersBanner;
